module.exports = __webpack_public_path__ + "static/img/productBg.08782bd.6f60766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sk/productBg.08782bd.png
// module id = dUKu
// module chunks = 16